module.exports = __webpack_public_path__ + "img/objective-4.13321e59.jpg";